export default "__VITE_ASSET__ChpdBJm8__"